module.exports = __webpack_public_path__ + "img/PD-01.3f546dd8.png";